import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'
import { isMovie } from '../utils/titleTypes'

export type SubPageType = 'Movie' | 'TVSeason'

export const imagesSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) =>
    detailFragment && detailFragment.images
)

export const liveStateSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) =>
    detailFragment && detailFragment.liveState
)

export const isMovieSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) =>
    isMovie(detailFragment && detailFragment.titleType)
)

export const subPageTypeSelector = createSelector(
  isMovieSelector,
  (isMovie): SubPageType => isMovie ? 'Movie' : 'TVSeason'
)

export const titleSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) =>
    detailFragment && detailFragment.title
)
